module.exports = __webpack_public_path__ + "media/stylesheets/images/main/default_profile-d057e09c0e3b03beb96a20f13af735e1.png";